import { useJdmVerifyCodeMutation } from '../../apis/jdmPasswordApi';
import { useCallback, useEffect, useState } from 'react';
import { useUsername } from '../useUsersSlice';
import { AlertType, TowerAlert } from '../../../../common/Alerts';

const useVerifyCode = () => {
    const { username: email } = useUsername();
    const [hasVerified, setHasVerified] = useState(false);
    const [isSyncedWithFf, setIsSyncedWithFf] = useState(false);
    const [usernameMatchesFF, setUsernameMatchesFF] = useState(false);
    const [alerts, setAlerts] = useState<TowerAlert[]>([]);

    const [verifyMutation, { isLoading, isSuccess, isError, data, error, reset }] =
        useJdmVerifyCodeMutation();

    // handle server success / error
    useEffect(() => {
        if (isSuccess && data) {
            if (data.valid) {
                setHasVerified(true);
                setIsSyncedWithFf(data.isSyncedWithFf);
                setUsernameMatchesFF(data.usernameMatchesFF);
            } else {
                setAlerts([{ type: AlertType.error, message: 'Invalid or expired code.' }]);
            }
        }
        if (isError) {
            const errorMessage = (error as any)?.data?.message || 'Verification failed. Please try again.';
            setAlerts([{ type: AlertType.error, message: errorMessage }]);
        }
    }, [isSuccess, isError, data, error]);

    const verifyContactCode = useCallback(
        (code: string) => {
            if (isLoading) {
                return Promise.resolve();
            }

            setAlerts([]);
            return verifyMutation({ code, username: email }).unwrap();
        },
        [isLoading, verifyMutation, email]
    );

    const resetState = useCallback(() => {
        setHasVerified(false);
        setIsSyncedWithFf(false);
        setUsernameMatchesFF(false);
        setAlerts([]);
        reset();
    }, [reset]);

    return {
        verifyContactCode,
        isLoading,
        alerts,
        hasVerified,
        isSyncedWithFf,
        usernameMatchesFF,
        reset: resetState,
    };
};

export default useVerifyCode;
